(() => {
  const KEY = 'gv_recent_products';
  const section = document.querySelector('[data-gv-recent]');
  const grid = document.querySelector('[data-gv-recent-grid]');
  const currentEl = document.getElementById('gv-recent-current');
  if (!section || !grid || !currentEl) return;

  let current = null;
  try {
    current = JSON.parse(currentEl.textContent || 'null');
  } catch (e) {
    return;
  }
  if (!current?.id) return;

  let list = [];
  try {
    list = JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch (e) {
    list = [];
  }

  list = list.filter((p) => p && p.id !== current.id);
  const others = list.slice(0, 4);
  list = [current, ...list].slice(0, 8);
  localStorage.setItem(KEY, JSON.stringify(list));

  if (!others.length) return;

  grid.innerHTML = others
    .map(
      (p, i) => `
    <a class="gv-p" href="${p.url}">
      <div class="gv-p__im" style="background: linear-gradient(158deg,#FBE3EC,#F1B9CE);">
        ${p.image ? `<img class="gv-p__img" src="${p.image}" alt="" loading="lazy" width="400" height="448">` : ''}
      </div>
      <h3 class="gv-p__title">${p.title}</h3>
      <div class="gv-p__pr">${p.price || ''}</div>
    </a>`
    )
    .join('');

  section.hidden = false;
})();
